import CircularProgress from '@material-ui/core/CircularProgress'
import React from 'react'

export const LoadingGraph = () =>
{
  return(
    <div style={{ height: 400, justifyContent: 'center', alignItems: 'center', display: 'flex' }}><CircularProgress /> </div>
  )
}